import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { BrandProvider } from "./contexts/BrandContext";
import ErrorBoundary from "./components/ErrorBoundary";
import HomePage from "./pages/HomePage";
import BrowsePage from "./pages/BrowsePage";
import VenueDetailPage from "./pages/VenueDetailPage";
import FavoritesPage from "./pages/FavoritesPage";
import ClaimVenuePage from "./pages/ClaimVenuePage";
import DashboardPage from "./pages/DashboardPage";
import AddLocationPage from "./pages/AddLocationPage";
import AdminPage from "./pages/AdminPage";
import ModerationPage from "./pages/ModerationPage";
import CorporatePage from "./pages/CorporatePage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiesPage from "./pages/CookiesPage";
import OwnerLoginPage from "./pages/OwnerLoginPage";
import AboutPage from "./pages/AboutPage";
import CityPage from "./pages/CityPage";
import CommunityPage from "./pages/CommunityPage";
import ContributorPage from "./pages/ContributorPage";
import ContributorAuthCallback from "./pages/ContributorAuthCallback";
import ContributorTermsPage from "./pages/ContributorTermsPage";
import WelcomePage from "./pages/WelcomePage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import GuidesPage from "./pages/GuidesPage";
import GuideDetailPage from "./pages/GuideDetailPage";
import InstallPrompt from "./components/InstallPrompt";
import { EzoicPageRefresh } from "./components/EzoicAd";
import { initAnalytics } from "./utils/analytics";
import { initializeSecurity } from "./utils/security";

function App() {
  // Initialize analytics and security on app mount
  useEffect(() => {
    initAnalytics();
    
    // Initialize security measures
    initializeSecurity({
      disableInspect: true,      // Disable right-click and dev tools shortcuts
      disableCopy: false,        // Keep copy enabled for user convenience
      showConsoleWarning: true,  // Show warning in console
      enableWatermark: true,     // Add print watermark
    });
  }, []);

  return (
    <HelmetProvider>
      <BrandProvider>
        <ErrorBoundary>
          <div className="App min-h-screen bg-sand">
            <BrowserRouter>
            {/* Ezoic: Refresh ads on page navigation for SPA */}
            <EzoicPageRefresh />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/browse" element={<BrowsePage />} />
              <Route path="/venue/:id" element={<VenueDetailPage />} />
              <Route path="/favorites" element={<FavoritesPage />} />
              <Route path="/claim" element={<ClaimVenuePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/owner-login" element={<OwnerLoginPage />} />
              <Route path="/add-location" element={<AddLocationPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/moderation" element={<ModerationPage />} />
              <Route path="/corporate" element={<CorporatePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route path="/contributor" element={<ContributorPage />} />
              <Route path="/contributor/auth/callback" element={<ContributorAuthCallback />} />
              <Route path="/contributor-terms" element={<ContributorTermsPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/city" element={<CityPage />} />
              <Route path="/city/:citySlug" element={<CityPage />} />
              <Route path="/welcome" element={<WelcomePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/guides" element={<GuidesPage />} />
              <Route path="/guides/:guideId" element={<GuideDetailPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
          <InstallPrompt />
        </div>
      </ErrorBoundary>
      </BrandProvider>
    </HelmetProvider>
  );
}

export default App;
